import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
import * as React from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { WaitProcessModal } from '@/components/Elements/WaitProcessModal';
import { useProducts } from '@/features/products';
import { useMe } from '@/hooks/useMe';
import { buildGTMPaidPlanData, sendEventGtm } from '@/lib/gtm/gtmUtils';
import { Currency, PricesTypes, ProductTypes } from '@/types';
import {
  getCurrencyFromPriceId,
  getProductLicensedPriceByCurrency,
  redirectMyRate,
  searchProductByPriceId,
} from '@/utils/helpers';

export const PurchasePage = () => {
  const productsQuery = useProducts();
  const { productPriceId } = useParams();
  const sendDataToGTM = useGTMDispatch();
  const { t, i18n } = useTranslation();
  const { isLoading: productsIsLoading = false, data: products } = productsQuery;
  const { getMe, isMeSet } = useMe();
  const isMe = isMeSet();

  useEffect(() => {
    if (!productsIsLoading && products && productPriceId && isMe) {
      const purchasedProducts: ProductTypes[] = searchProductByPriceId(products, productPriceId);
      if (purchasedProducts.length <= 0) {
        return;
      }

      const purchasedProduct = purchasedProducts[0];
      const purchaseCurrency = getCurrencyFromPriceId(purchasedProduct, productPriceId) as Currency;
      const productPrice: PricesTypes = getProductLicensedPriceByCurrency(
        purchasedProduct.prices,
        purchaseCurrency
      );
      sendEventGtm(
        buildGTMPaidPlanData(purchasedProduct, productPrice, i18n.language, getMe()),
        sendDataToGTM
      );
    }
  }, [productsIsLoading, products, sendDataToGTM, productPriceId, i18n, getMe, isMe]);

  return (
    <WaitProcessModal
      title={t('Forms.checkoutSuccess')}
      description={t('Forms.checkoutSuccessDescription')}
      isOpen={true}
      timeoutCallback={redirectMyRate}
      timeInMS={8000}
    />
  );
};
